module.exports = __webpack_public_path__ + "img/calendar-white.443d4435.svg";